export enum EnumTextTypes {
    main = 'main',
    description = 'description'
}